
// @ts-ignore
import {translate} from '@elements/translations';
import {ref, computed, reactive, onMounted, defineComponent} from 'vue';
import {useActivityStore} from '../../stores/ActivityStore';
import {storeToRefs} from 'pinia'
import BasePrice from "../../components/price-tendencies/BasePrice.vue";
import PriceLegendActivities from "../../components/price-tendencies/PriceLegendActivities.vue";
import Calendar from "../../components/calendar/Calendar.vue";
import CalendarSelection from "../../components/calendar/CalendarSelection.vue";

export default defineComponent({
    name: 'CalendarView',
    components: {
        BasePrice,
        Calendar,
        CalendarSelection,
        PriceLegendActivities
    },
    props: {
        title: {
            type: String,
            required: true,
        },
        activityId: {
            type: String,
            required: true,
        },
        isTimeList: {
            type: Boolean,
            required: false,
            default: false
        }
    },
    setup(props) {
        const activityStore = useActivityStore();
        const {
            step,
            selectedDateStart,
            selectedDateEnd,
        } = storeToRefs(activityStore);

        const {changeStep, changeDateStart, changeDateEnd, changeHideServiceView, resetServiceStep} = activityStore

        const isMobile = matchMedia('(max-width: 767px)').matches;

        const onChangeStep = (step: number) => {
            changeStep(step);
        }

        const onChangeDateStart = (date: string) => {
            changeDateStart(date);
            resetServiceStep();
        }

        const onChangeDateEnd = (date: string) => {
            changeDateEnd(date);
            resetServiceStep();
        }

        return {
            step,
            selectedDateStart,
            selectedDateEnd,
            changeStep,
            onChangeStep,
            onChangeDateStart,
            onChangeDateEnd,
            isMobile,
            translate
        };
    }
});
